// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2AKJI","colMin":"styles_colMin__2nQgC","colCheckbox":"styles_colCheckbox__1yW_J"};